import React from 'react';
import StaticNavigation from './StaticNavigation';
import styles from './AboutStaticPage.css';

const AboutStaticPage = () => (
  <div className={styles.container}>
    <StaticNavigation title="About Us" />
    <p className={styles.aboutContent}>
      Covetrus makes filling your animal’s prescription easy in combination with
      Roadrunner Pharmacy. Our pharmacists ensure the highest level of quality
      to meet your pet’s specific medication needs.
    </p>
    <h1 className={styles.aboutTitle}>The Benefits of using Fast Fill:</h1>
    <ul className={styles.aboutList}>
      <li>
        <span>Free Shipping</span>
        <ul>
          <li>We offer free shipping for all orders.</li>
        </ul>
      </li>
      <li>
        <span>Quality Guarantee</span>
        <ul>
          <li>
            We are committed to quality control and quality assurance for all
            prescriptions.
          </li>
        </ul>
      </li>
      <li>
        <span>Refill Reminders</span>
        <ul>
          <li>
            Never forget to refill your animal’s prescription. We will send you
            a reminder when your refill is due.
          </li>
        </ul>
      </li>
    </ul>
  </div>
);

export default AboutStaticPage;



// WEBPACK FOOTER //
// ./src/components/StaticPages/AboutStaticPage.jsx